import { useState, useCallback } from 'react'
import {
  useVideosContext,
  hasVideosInProgress
} from '../context/videos-context'

export const useProcessingWarning = () => {
  const { state } = useVideosContext()
  const [showWarning, setShowWarning] = useState(false)
  const [pendingCloseCallback, setPendingCloseCallback] = useState<
    (() => void) | null
  >(null)

  const requestClose = useCallback(
    (onConfirm: () => void) => {
      if (hasVideosInProgress(state.videos)) {
        setShowWarning(true)
        setPendingCloseCallback(() => onConfirm)
      } else {
        onConfirm()
      }
    },
    [state.videos]
  )

  const handleCancelWarning = useCallback(() => {
    setShowWarning(false)
    setPendingCloseCallback(null)
  }, [])

  const handleConfirmWarning = useCallback(() => {
    setShowWarning(false)
    if (pendingCloseCallback) {
      pendingCloseCallback()
    }
    setPendingCloseCallback(null)
  }, [pendingCloseCallback])

  return {
    showWarning,
    requestClose,
    handleCancelWarning,
    handleConfirmWarning
  }
}
